import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index/index'
import About from '@/components/abous'
import Save from '@/components/save'
import DemAnd from '@/components/demand/index'
import DemAndArt from '@/components/demand/seekarticle'
import DemAndArtSupply from '@/components/demand/supplyarticle'
import Join from '@/components/join/index'
import Cooperate from '@/components/cooperate'
import Info from '@/components/news/index'
import Article from '@/components/news/article'
import IndexInfo from '@/components/market/index'
import IndexMarket from '@/components/market/article'
import JoinArt from '@/components/join/article'
import SettLed from '@/components/settled'




Vue.use(Router)

export default new Router({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [{
      path: '/',
      redirect: '/index',
    },
    {
      path: '/index',
      component: Index
    },
    {
      path: '/abous',
      component: About
    },
    {
      path: '/save',
      component: Save
    },
    {
      path: '/demand',
      component: DemAnd
    },
    {
      path: '/demand/seekarticle/id/:id/member/:memberId/company/:companyId',
      component: DemAndArt,
      name:'demAndArt'
    },

    {
      path: '/demand/supplyarticle/id/:id/member/:memberId/company/:companyId',
      component: DemAndArtSupply,
      name:'demAndArtSupply'
    },

    {
      path: '/cooperate',
      component: Cooperate
    },
    {
      path: '/news',
      component: Info
    },
    {
      path: '/join/index',
      component: Join
    },

    {
      path: '/news/article/:id',
      component: Article
    },
    {
      path: '/market',
      component: IndexInfo
    },
    {
      path: '/market/article/:id',
      component: IndexMarket
    },
    {
      path: '/join/article',
      component: JoinArt
    },
    {
      path: '/settled',
      component: SettLed
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    // 如果是返回的历史记录，恢复之前的滚动位置
    if (savedPosition) {
      return savedPosition
    }
    // 否则，跳转到页面顶部
    return {
      x: 0,
      y: 0
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js